import { ChannelType } from 'components/CampaignCreationModal/Types'
import markdownit from 'markdown-it'

const md = markdownit()
type Token = ReturnType<typeof md.parse>[number]

const getTextContent = (token: Token): string => {
  if (token.type === 'text') return token.content
  if (token.type === 'inline' && token.children) {
    return token.children.map(getTextContent).join('')
  }
  return ''
}

const extractContent = (tokens: Token[], openTokenType: string, closeTokenType: string): string[] => {
  const items: string[] = []
  let currentItem: string[] = []
  let inContent = false

  for (const token of tokens) {
    if (token.type === openTokenType) {
      inContent = true
      currentItem = []
    } else if (token.type === closeTokenType) {
      inContent = false
      if (currentItem.length > 0) {
        items.push(currentItem.join(''))
      }
    } else if (inContent && token.type === 'inline') {
      currentItem.push(getTextContent(token))
    }
  }

  return items
}

const getAllListItems = (tokens: Token[], channel: ChannelType): string[] => {
  switch (channel) {
    case ChannelType.Tweets:
    case ChannelType.InstagramPosts:
    case ChannelType.InstagramCaptions:
      return extractContent(tokens, 'list_item_open', 'list_item_close')

    case ChannelType.LinkedInPosts:
    case ChannelType.FacebookPost:
      return extractContent(tokens, 'paragraph_open', 'paragraph_close')

    default:
      return []
  }
}

export const extractAllOptions = (content: string, channel: ChannelType): string[] => {
  const tokens = md.parse(content, {})

  return getAllListItems(tokens, channel).filter((item) => !item.startsWith('#'))
}
